import React from "react";
import { ReactSVG } from "react-svg";
import { getSubdomain } from "../config/StylesheetInjector";
import imageRegistry from "../constants/imageRegistry";

const Header = () => {
  const sub = getSubdomain();

  return (
    <div className='header-container'>
      <ReactSVG src={imageRegistry[sub]} width={180} height={80} />
    </div>
  );
};

export default Header;
